import { QESCheckbox } from "@app/shared/qes-standards";
import { uniqueId } from "lodash";
import { FC } from "react";

interface AccuracyInspectionSummaryAdditionalDataSectionProps {
  onShowPercentageColumnsChange: (isChecked: boolean) => void;
  onShowExpandedOutcomesChange: (isChecked: boolean) => void;
  showPercentageColumns: boolean;
  showExpandedOutcomes: boolean;
}

const AccuracyInspectionSummaryAdditionalDataSection: FC<AccuracyInspectionSummaryAdditionalDataSectionProps> = (props: AccuracyInspectionSummaryAdditionalDataSectionProps) => {
  return (
    <>
      <p className="lead mb0 font-weight-bold">Additional Data</p>
      <p>Please select the data categories you want:</p>
      <QESCheckbox
        key={"includePercentageColumns"}
        id={uniqueId("includePercentageColumns")}
        label={"Include percentage columns"}
        containerClassName="form-check"
        className="form-check-input mt-0"
        checked={props.showPercentageColumns}
        onChange={(e) => props.onShowPercentageColumnsChange(e.target.checked)}
        testId={`export-accuracy-show-percentage-columns-checkbox`}
      />
      <QESCheckbox
        key={"includeExpandedOutcomes"}
        id={uniqueId("includeExpandedOutcomes")}
        label={"Include expanded outcomes data"}
        containerClassName="form-check"
        className="form-check-input mt-0"
        checked={props.showExpandedOutcomes}
        onChange={(e) => props.onShowExpandedOutcomesChange(e.target.checked)}
        testId={`export-accuracy-show-expanded-outcomes-checkbox`}
      />
    </>
  );
}

export default AccuracyInspectionSummaryAdditionalDataSection;